/* Jeu à gratter — Le Temple du Foot
   Réglages dans l'éditeur de thème (section « Jeu à gratter »). Test : ?gratte=1 (force l'ouverture, remet à zéro).
   31/10/2026 : une seule ouverture automatique par visiteur (st.last posé dès l'affichage), puis cooldown du réglage.
   Dans l'éditeur de thème, le popup ne s'ouvre QUE quand on sélectionne la section (plus à chaque page). */
(function(){
  var root=document.getElementById('ltdf-scratch');if(!root)return;
  var D=root.dataset;
  var KEY='ltdf_scratch_v1';
  var code=D.code||'',delay=(parseFloat(D.delay)||6)*1000,cooldown=(parseFloat(D.cooldown)||24)*3600000,hours=parseFloat(D.hours)||24;
  var endFixed=D.end?new Date(D.end).getTime():0;if(isNaN(endFixed))endFixed=0;
  var requireEmail=D.requireEmail==='true',chipOn=D.chip==='true';
  var design=document.documentElement.classList.contains('shopify-design-mode');
  var forced=/[?&]gratte=1/.test(location.search);
  var $=function(id){return document.getElementById(id);};
  var canvas=$('lscCanvas'),zone=$('lscZone'),hint=$('lscHint'),revealBtn=$('lscReveal'),form=$('lscForm'),email=$('lscEmail'),err=$('lscErr'),unlock=$('lscUnlock'),copyBtn=$('lscCopy'),countEl=$('lscCount'),countL=$('lscCountL');

  function load(){try{return JSON.parse(localStorage.getItem(KEY)||'null')||{};}catch(e){return {};}}
  function save(o){try{localStorage.setItem(KEY,JSON.stringify(o));}catch(e){}}
  var st=load();
  if(forced){st={};save(st);}

  /* ---------- compte à rebours : date fixe, sinon N heures par visiteur à partir du premier affichage ---------- */
  function endTime(){
    if(endFixed)return endFixed;
    if(!st.first){st.first=Date.now();save(st);}
    return st.first+hours*3600000;
  }
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    var diff=endTime()-Date.now();
    if(diff<=0){countEl.classList.add('is-over');countL.textContent='Offre terminée';return;}
    var d=Math.floor(diff/86400000),h=Math.floor(diff%86400000/3600000),m=Math.floor(diff%3600000/60000),s=Math.floor(diff%60000/1000);
    var du=root.querySelector('[data-cu="d"]');if(du)du.classList.toggle('is-hidden',d===0);
    var map={d:d,h:h,m:m,s:s};root.querySelectorAll('[data-c]').forEach(function(b){b.textContent=pad(map[b.getAttribute('data-c')]);});
    var chip=document.querySelector('.lsc-chip i');if(chip)chip.textContent=d>0?(d+' j '+pad(h)+' h'):(pad(h)+' h '+pad(m)+' min');
  }

  /* ---------- tracking (pixels Shopify, GTM, GA4, Meta si présents) ---------- */
  function track(name,data){
    var d=Object.assign({popup:'jeu-a-gratter',code:code},data||{});
    try{if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish)Shopify.analytics.publish(name,d);}catch(e){}
    try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:name},d));}catch(e){}
    try{if(typeof gtag==='function')gtag('event',name,d);}catch(e){}
    try{if(typeof fbq==='function')fbq('trackCustom',name,d);}catch(e){}
  }

  /* ---------- ouverture / fermeture ---------- */
  var timer=null,curStep=1;
  function step(n){
    curStep=n;root.querySelectorAll('.lsc-step').forEach(function(el){el.classList.toggle('is-on',el.getAttribute('data-step')===String(n));});
    root.querySelector('.lsc-card').scrollTop=0;
    if(n===3){track('ltdf_scratch_code_shown');}
  }
  function open(startStep){
    if(!root.hidden)return;
    root.hidden=false;root.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
    step(startStep||1);
    if((startStep||1)===1){requestAnimationFrame(paint);}
    tick();timer=setInterval(tick,1000);
    requestAnimationFrame(function(){root.classList.add('is-on');});
    track('ltdf_scratch_open',{step:startStep||1});
  }
  function close(){
    if(root.hidden)return;
    root.classList.remove('is-on');
    st.last=Date.now();save(st);
    track('ltdf_scratch_closed',{step:curStep});
    setTimeout(function(){root.hidden=true;root.setAttribute('aria-hidden','true');document.documentElement.style.overflow='';if(timer)clearInterval(timer);timer=null;},260);
  }
  var lastScratch=0;
  root.querySelectorAll('[data-lsc-close]').forEach(function(el){el.addEventListener('click',function(e){if(el.classList.contains('lsc-bg')&&e.target!==el)return;if(Date.now()-lastScratch<500)return;close();});});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});

  /* ---------- ticket : peinture du film à gratter ---------- */
  var ctx,W=0,H=0,drawing=false,done=false,last=null,moves=0;
  function shirt(c,x,y,s,alpha){
    c.save();c.translate(x,y);c.scale(s,s);c.globalAlpha=alpha;c.fillStyle='#fff';
    c.beginPath();c.moveTo(7.2,3.2);c.lineTo(9.6,2.2);c.bezierCurveTo(10.2,3.6,11.1,4.2,12,4.2);c.bezierCurveTo(12.9,4.2,13.8,3.6,14.4,2.2);c.lineTo(16.8,3.2);c.lineTo(20.8,6);c.lineTo(18.8,9.6);c.lineTo(16.6,8.7);c.lineTo(16.6,21.5);c.lineTo(7.4,21.5);c.lineTo(7.4,8.7);c.lineTo(5.2,9.6);c.lineTo(3.2,6);c.closePath();c.fill();c.restore();
  }
  function paint(){
    W=zone.clientWidth;H=zone.clientHeight;if(!W||!H)return;
    var r=Math.min(window.devicePixelRatio||1,2);canvas.width=W*r;canvas.height=H*r;ctx=canvas.getContext('2d');ctx.setTransform(r,0,0,r,0,0);
    var g=ctx.createLinearGradient(0,0,W,H);g.addColorStop(0,'#1a1a1a');g.addColorStop(.5,'#2b2b2b');g.addColorStop(1,'#151515');ctx.fillStyle=g;ctx.fillRect(0,0,W,H);
    ctx.save();ctx.globalAlpha=.16;ctx.strokeStyle=getComputedStyle(root).getPropertyValue('--lsc-accent').trim()||'#2d6a4f';ctx.lineWidth=10;
    for(var i=-H;i<W+H;i+=34){ctx.beginPath();ctx.moveTo(i,0);ctx.lineTo(i+H,H);ctx.stroke();}ctx.restore();
    var sz=0.9,stepX=44,stepY=40;for(var yy=-10,row=0;yy<H+20;yy+=stepY,row++){for(var xx=(row%2?22:0)-10;xx<W+20;xx+=stepX){shirt(ctx,xx,yy,sz,.07);}}
    var sh=ctx.createLinearGradient(0,0,W,0);sh.addColorStop(0,'rgba(255,255,255,0)');sh.addColorStop(.45,'rgba(255,255,255,.08)');sh.addColorStop(.55,'rgba(255,255,255,.08)');sh.addColorStop(1,'rgba(255,255,255,0)');ctx.fillStyle=sh;ctx.fillRect(0,0,W,H);
    ctx.globalCompositeOperation='destination-out';
    ctx.beginPath();var x0=W*0.62,y0=H;ctx.moveTo(x0,H+4);
    var px=x0,py=H;for(var k=0;k<=14;k++){var t=k/14;px=x0+(W+4-x0)*t;py=H-(H*0.62)*t+Math.sin(k*2.1)*7+(k%3?4:-6);ctx.lineTo(px,py);}
    ctx.lineTo(W+4,H+4);ctx.closePath();ctx.fill();
    ctx.globalCompositeOperation='source-over';
    for(var q=0;q<48;q++){var t2=q/48,fx=x0+(W-x0)*t2+(Math.random()*18-9),fy=H-(H*0.62)*t2+(Math.random()*22-11);ctx.fillStyle='rgba(225,225,225,'+(0.25+Math.random()*0.45)+')';ctx.beginPath();ctx.ellipse(fx,fy,2+Math.random()*5,1+Math.random()*2.5,Math.random()*3,0,Math.PI*2);ctx.fill();}
    ctx.globalCompositeOperation='destination-out';
    done=false;canvas.classList.remove('is-done');hint.classList.remove('is-hidden');zone.classList.remove('is-won');
  }
  function pos(e){var b=canvas.getBoundingClientRect();var t=e.touches?e.touches[0]:e;return {x:t.clientX-b.left,y:t.clientY-b.top};}
  function scratch(p){
    if(!ctx)return;var rad=Math.max(22,Math.min(W,H)*0.09);
    ctx.beginPath();if(last){ctx.lineWidth=rad*2;ctx.lineCap='round';ctx.strokeStyle='#000';ctx.moveTo(last.x,last.y);ctx.lineTo(p.x,p.y);ctx.stroke();}
    ctx.beginPath();ctx.arc(p.x,p.y,rad,0,Math.PI*2);ctx.fill();last=p;
    if(++moves%6===0)check();
  }
  function check(){
    if(done||!ctx)return;
    var data=ctx.getImageData(0,0,canvas.width,canvas.height).data,clear=0,step=16,total=0;
    for(var i=3;i<data.length;i+=4*step){total++;if(data[i]<40)clear++;}
    if(clear/total>0.5)win();
  }
  function win(){
    if(done)return;done=true;
    canvas.classList.add('is-done');hint.classList.add('is-hidden');zone.classList.add('is-won');
    st.won=Date.now();save(st);track('ltdf_scratch_won');
    setTimeout(function(){step(requireEmail&&!st.unlocked?2:3);if(!requireEmail){unlocked();}},1100);
  }
  function onDown(e){if(done)return;drawing=true;last=null;hint.classList.add('is-hidden');scratch(pos(e));e.preventDefault();}
  function onMove(e){if(!drawing||done)return;scratch(pos(e));e.preventDefault();}
  function onUp(){if(drawing)lastScratch=Date.now();drawing=false;last=null;check();}
  canvas.addEventListener('mousedown',onDown);canvas.addEventListener('mousemove',onMove);window.addEventListener('mouseup',onUp);
  canvas.addEventListener('touchstart',onDown,{passive:false});canvas.addEventListener('touchmove',onMove,{passive:false});window.addEventListener('touchend',onUp);
  window.addEventListener('resize',function(){if(!root.hidden&&!done&&curStep===1)paint();});
  if(revealBtn)revealBtn.addEventListener('click',win);

  /* ---------- e-mail → Klaviyo ---------- */
  form.addEventListener('submit',function(e){
    e.preventDefault();var v=(email.value||'').trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){err.textContent='Entre une adresse e-mail valide.';err.hidden=false;email.focus();return;}
    err.hidden=true;unlock.disabled=true;unlock.textContent='…';
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(D.company),{method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},
      body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Jeu à gratter (site)',profile:{data:{type:'profile',attributes:{email:v,properties:{jeu_gratter:true,jeu_gratter_code:code}}}}},relationships:{list:{data:{type:'list',id:D.list}}}}})})
    .then(function(r){if(r.status===202||r.ok){st.email=1;save(st);track('ltdf_scratch_email');unlocked();}else{throw new Error('ko');}})
    .catch(function(){err.textContent='Oups, réessaie dans un instant.';err.hidden=false;})
    .finally(function(){unlock.disabled=false;unlock.textContent=unlock.getAttribute('data-label');});
  });
  function unlocked(){st.unlocked=Date.now();save(st);step(3);chip();}

  /* ---------- code : copier ---------- */
  copyBtn.addEventListener('click',function(){
    var t=code;function ok(){copyBtn.textContent='Copié ✓';copyBtn.classList.add('is-ok');setTimeout(function(){copyBtn.textContent=copyBtn.getAttribute('data-label');copyBtn.classList.remove('is-ok');},1800);}
    if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(t).then(ok,ok);}else{var ta=document.createElement('textarea');ta.value=t;document.body.appendChild(ta);ta.select();try{document.execCommand('copy');}catch(e){}ta.remove();ok();}
  });

  /* ---------- rappel discret en bas à gauche une fois le code débloqué ---------- */
  function chip(){
    if(!chipOn||!st.unlocked||st.chipClosed||document.querySelector('.lsc-chip'))return;
    if(endTime()-Date.now()<=0)return;
    var a=document.createElement('a');a.className='lsc-chip';a.href=root.querySelector('#lscUse').getAttribute('href');
    a.style.setProperty('--lsc-chip-accent',getComputedStyle(root).getPropertyValue('--lsc-accent').trim()||'#d6ff3d');
    a.innerHTML='<span>Ton code</span><b>'+code+'</b><i></i><span class="lsc-chip-x" aria-label="Masquer">×</span>';
    a.querySelector('.lsc-chip-x').addEventListener('click',function(e){e.preventDefault();e.stopPropagation();st.chipClosed=1;save(st);a.remove();});
    document.body.appendChild(a);tick();if(!timer)timer=setInterval(tick,1000);
  }

  /* ---------- armement ---------- */
  window.ltdfScratchOpen=function(){open(st.unlocked?3:1);};
  document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href="#gratte"]');if(a){e.preventDefault();window.ltdfScratchOpen();}});
  function arm(){
    if(forced){open(1);return;}
    if(design){
      /* éditeur de thème : ouverture seulement quand la section « Jeu à gratter » est sélectionnée */
      var sec=root.closest('.shopify-section');
      document.addEventListener('shopify:section:select',function(e){if(sec&&e.target===sec)open(1);});
      document.addEventListener('shopify:section:deselect',function(e){if(sec&&e.target===sec)close();});
      return;
    }
    if(st.unlocked){chip();return;}
    if(endTime()-Date.now()<=0&&!endFixed){st={};save(st);}
    if(st.last&&Date.now()-st.last<cooldown)return;
    var fired=false;function go(){if(fired)return;fired=true;st.last=Date.now();save(st);open(st.won?2:1);}
    setTimeout(go,delay);
    document.addEventListener('mouseleave',function(e){if(e.clientY<=0)go();});
  }
  arm();
})();
